document.addEventListener("DOMContentLoaded", function () {

  const faqItems = document.querySelectorAll(".gapp_faq-item");

  faqItems.forEach((item) => {
    const question = item.querySelector(".gapp_faq-question");
    const answer = item.querySelector(".gapp_faq-answer");

    const plusIcon = item.querySelector(".faq_plus_icon");
    const minusIcon = item.querySelector(".faq_minus_icon");

    // Base styles
    answer.style.overflow = "hidden";
    answer.style.transition = "height 0.4s ease";

    // ✅ Check if already active (Liquid thi)
    if (item.classList.contains("active")) {
      answer.style.height = answer.scrollHeight + "px";
      if (plusIcon) plusIcon.style.display = "none";
      if (minusIcon) minusIcon.style.display = "inline-block";
    } else {
      answer.style.height = "0px";
      if (plusIcon) plusIcon.style.display = "inline-block";
      if (minusIcon) minusIcon.style.display = "none";
    }

    question.addEventListener("click", () => {

      const isOpen = item.classList.contains("active");

      // 🔁 Close all
      faqItems.forEach((el) => {
        el.classList.remove("active");
        const ans = el.querySelector(".gapp_faq-answer");
        const plus = el.querySelector(".faq_plus_icon");
        const minus = el.querySelector(".faq_minus_icon");

        ans.style.height = "0px";
        if (plus) plus.style.display = "inline-block";
        if (minus) minus.style.display = "none";
      });

      // ✅ Open current
      if (!isOpen) {
        item.classList.add("active");

        answer.style.height = answer.scrollHeight + "px";

        if (plusIcon) plusIcon.style.display = "none";
        if (minusIcon) minusIcon.style.display = "inline-block";
      }
    });
  });

});